module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "new_soproni_small_area"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.orders), function(order) {
    return _c('section', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "ked_menu_box"
    }, [_c('div', {
      staticClass: "ked_menu_box_cont"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-6"
    }, [_c('div', {
      staticClass: "rendel_date"
    }, [_c('p', [_vm._v(_vm._s(new Date(order.placedOn).customFormat('#YYYY#-#MM#-#DD# #hhhh#:#mm#')))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6"
    }, [_c('div', {
      staticClass: "rendel_first_total"
    }, [_c('h6', [_vm._v(_vm._s(_vm.status[order.status]) + " "), (order.status == 'PREPARED_FOR_PAYMENT') ? _c('a', {
      staticStyle: {
        "font-size": "18px"
      },
      on: {
        "click": function($event) {
          _vm.payOrder(order.id)
        }
      }
    }, [_vm._v("- Kifizetés")]) : _vm._e(), _vm._v(" "), (order.status.includes('PREPARED')) ? _c('a', {
      staticStyle: {
        "font-size": "18px"
      },
      on: {
        "click": function($event) {
          _vm.cancelOrder(order.id)
        }
      }
    }, [_vm._v("- Törlés")]) : _vm._e()])])])])])])])]), _vm._v(" "), _vm._l((order.basket.basketElements), function(be) {
      return _c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "kedvenciam_all_area"
      }, [_c('div', {
        staticClass: "col-sm-12"
      }, [_c('div', {
        staticClass: "single_kedvenciam_all"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-sm-3"
      }, [_c('div', {
        staticClass: "kedvenciam_all_small_can"
      }, [_c('img', {
        attrs: {
          "src": be.product.imageUrl,
          "alt": ""
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-3"
      }, [_c('div', {
        staticClass: "kedvenciam_all_small_title"
      }, [_c('h6', [_vm._v(_vm._s(be.product.name))])])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-1"
      }, [_c('div', {
        staticClass: "kedvenciam_all_quantity_small_title"
      }, [_c('p', [_vm._v(_vm._s((be.soldPrice || be.product.price).toLocaleString('hu')) + " Ft")])])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-1"
      }, [_c('div', {
        staticClass: "kedvenciam_all_quantity_small_title"
      }, [_c('p', [_vm._v(_vm._s(be.quantity) + " db")])])]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-3"
      }, [_c('div', {
        staticClass: "thm_btn_boxes"
      }, [_c('div', {
        staticClass: "ozz_btn text-center"
      }, [_c('p', [_vm._v(_vm._s(be.priceTotal && be.priceTotal.toLocaleString('hu')) + " Ft")])])])])])])])])])
    }), _vm._v(" "), _c('div', {
      staticClass: "row last-div"
    }, [_c('div', {
      staticClass: "kedvenciam_all_area"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "single_kedvenciam_all again_bg"
    }, [_c('div', {
      staticClass: "row"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6"
    }, [_c('div', {
      staticClass: "total_termekek_results text-right"
    }, [_c('p', {
      staticClass: "res_ter bl_red"
    }, [_vm._v("\n                                            " + _vm._s(order.basket.priceTotalWithPackage && order.basket.priceTotalWithPackage.toLocaleString('hu')) + " (net.: " + _vm._s((order.basket.priceTotalWithPackage / 1.27).toFixed(0).toLocaleString('hu')) + ") Ft\n                                        ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6"
    }, [_c('div', {
      staticClass: "total_termekek_results text-right"
    }, [_c('p', {
      staticClass: "res_ter bl_red"
    }, [_vm._v("\n                                            Bruttó tömeg: " + _vm._s(order.basket.productExtra.grossWeight / 1000) + " kg\n                                        ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6"
    }, [_c('div', {
      staticClass: "total_termekek_results text-right"
    }, [_c('p', {
      staticClass: "res_ter bl_red"
    }, [_vm._v("\n                                            " + _vm._s(order.basket.priceTotalWithPackage && order.basket.priceTotalWithPackage.toLocaleString('hu')) + " Ft\n                                        ")])])])]), _vm._v(" "), (order.shipping.shippingMode == 'SHIPPING') ? _c('div', {
      staticClass: "row"
    }, [_vm._m(4, true), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6"
    }, [_c('div', {
      staticClass: "total_termekek_results text-right"
    }, [_c('p', {
      staticClass: "res_ter bl_red"
    }, [_vm._v("\n                                            " + _vm._s((order.basket.priceTotalWithShipping - order.basket.priceTotalWithPackage).toLocaleString('hu')) + " Ft\n                                            "), (order.shipping.crackAssistance) ? _c('span', [_vm._v("\n                                                + " + _vm._s(((order.basket.priceTotalWithShipping - order.basket.priceTotalWithPackage) * 0.75).toFixed(0).toLocaleString('hu')) + " Ft törésbiztosítás\n                                            ")]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(5, true), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6"
    }, [_c('div', {
      staticClass: "total_termekek_results text-right"
    }, [_c('p', {
      staticClass: "res_ter bl_red"
    }, [_vm._v("\n                                            " + _vm._s(order.payment.finalPrice && order.payment.finalPrice.toLocaleString('hu')) + " Ft\n                                        ")])])])])])])])])], 2)
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "section_title_box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "section_title"
  }, [_c('div', {
    staticClass: "section_title_cont text-left"
  }, [_c('h3', [_vm._v("RENDELÉSEIM")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "termekek_title again"
  }, [_c('p', {
    staticClass: "new_rester"
  }, [_vm._v("Termékek összesen: ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "termekek_title again"
  }, [_c('p', {
    staticClass: "new_rester"
  }, [_vm._v("Csomag tömege: ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "termekek_title again"
  }, [_c('p', {
    staticClass: "new_rester"
  }, [_vm._v("Csomag teljes bruttó ára: ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "termekek_title again"
  }, [_c('p', {
    staticClass: "new_rester"
  }, [_vm._v("Szállítási díj: ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "termekek_title again"
  }, [_c('p', {
    staticClass: "new_rester"
  }, [_vm._v("Összesen: ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ecd8932c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/pages/dashboard/orders/Orders.vue
// module id = 290
// module chunks = 2